import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('QUANTUM_TUNNEL', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const count = 12;
  for (let i = 0; i < count; i++) {
    const angle = (i / count) * Math.PI * 2;
    const startR = 100 * (1 - progress);
    const endR = 200 * (1 - progress);
    ctx.strokeStyle = determineColor(i, count);
    ctx.globalAlpha = progress;
    ctx.beginPath();
    ctx.moveTo(e.pos.x + Math.cos(angle) * startR, e.pos.y + Math.sin(angle) * startR);
    ctx.lineTo(e.pos.x + Math.cos(angle) * endR, e.pos.y + Math.sin(angle) * endR);
    ctx.stroke();
  }
});
